// const type = "pre";

interface EnvironmentType {
  baseURL: string;
  siteId: string;
  previewURL: string;
  goodUrl: string;
  adminUrl: string;
  imgURL: string;
  appkey: string;
  menuId: number;
  newMenuId: number;
  secret: string;
  iframeUrl: string;
  type: string;
}

let type = '';
let environment: {[key: string]: EnvironmentType};
if (process.env.NODE_ENV !== 'production') {
  // 本地运行
  type = process.env.NODE_ENV === 'development' ? 'pre' : process.env.NODE_ENV;
  environment = {
    prod: {
      baseURL: '//spapi.seatent.com',
      siteId: '99cea281725792cfefc2737e7f5ecb3d',
      previewURL: 'https://active.seatent.com',
      goodUrl: 'http://home.seatent.com',
      adminUrl: 'http://support.seatent.com',
      imgURL: '//statics.seatent.com',
      appkey: '89025026',
      menuId: 10086,
      newMenuId: 10001,
      secret: 'f330eee90f974110bd194b4e9da67fd1',
      iframeUrl: 'http://localhost:4200',
      type: 'prod',
    },
    pre: {
      baseURL: '//demo.saaspre.seatent.com',
      imgURL: '//img.demo.saaspre.seatent.com',
      siteId: '6b8b4690e7a727e3a330a308fe136a2e',
      previewURL: 'http://active.pre.seatent.com',
      goodUrl: 'http://home.pre.seatent.com',
      adminUrl: 'http://support.pre.seatent.com',
      appkey: '89025026',
      menuId: 10086,
      newMenuId: 10001,
      secret: 'f330eee90f974110bd194b4e9da67fd1',
      iframeUrl: 'http://localhost:4200',
      type: 'pre',
    },
    qa1: {
      baseURL: '//demo.saaspre.seatent.com',
      imgURL: '//img.demo.saaspre.seatent.com',
      siteId: '155627326e5011c18d147ec6067d053d',
      previewURL: 'http://active.qa1.seatent.com',
      goodUrl: 'http://home.qa1.seatent.com',
      adminUrl: 'http://support.qa1.seatent.com',
      appkey: '89025026',
      menuId: 10086,
      newMenuId: 10001,
      secret: 'ae46d058db1ebd6d3ff107ecf2e8960f',
      iframeUrl: 'http://localhost:4200',
      type: 'pre',
    },
    dev: {
      baseURL: '//localhost:7001',
      imgURL: '//img.qa1.seatent.com',
      siteId: '155627326e5011c18d147ec6067d053d',
      previewURL: 'http://active.qa1.seatent.com',
      goodUrl: 'http://home.qa1.seatent.com',
      adminUrl: 'http://support.qa1.seatent.com',
      appkey: '89025026',
      menuId: 10086,
      newMenuId: 10001,
      secret: 'ae46d058db1ebd6d3ff107ecf2e8960f',
      iframeUrl: 'http://localhost:4200',
      type: 'pre',
    },
  };
} else {
  // 线上运行
  type = 'prod';
  const loc = window.location;
  const url = loc.host;
  let sitId = '';
  let secret = '';
  interface SiteIdObjType {
    siteId: string;
    secret: string;
  }
  const siteIdObj: {[key: string]: SiteIdObjType} = {
    'saasportal.demo.saaspre.seatent.com': {
      siteId: '155627326e5011c18d147ec6067d053d',
      secret: 'f330eee90f974110bd194b4e9da67fd1',
    },
    'saasportal.demo.saas.seatent.com': {
      siteId: '155627326e5011c18d147ec6067d053d',
      secret: 'f330eee90f974110bd194b4e9da67fd1',
    },
    'saasportal.seatent.com': {
      siteId: '155627326e5011c18d147ec6067d053d',
      secret: 'f330eee90f974110bd194b4e9da67fd1',
    },
    'saasportal.saaspre.seatent.com': {
      siteId: '155627326e5011c18d147ec6067d053d',
      secret: 'f330eee90f974110bd194b4e9da67fd1',
    },
  };
  Object.keys(siteIdObj).forEach((key) => {
    const reg = new RegExp(key);
    if (reg.test(url)) {
      sitId = siteIdObj[key].siteId;
      secret = siteIdObj[key].secret;
    }
  });
  environment = {
    prod: {
      baseURL: url.indexOf('pre') > -1 ? `${loc.protocol}//demo.saaspre.seatent.com` : `${loc.protocol}//saa.s.seatent.com`,
      siteId: sitId,
      previewURL: `${loc.protocol}//${url.replace('supportv1', 'active')}`,
      goodUrl: `${loc.protocol}//${url.replace('supportv1', 'home')}`,
      adminUrl: `${loc.protocol}//${url.replace('supportv1', 'support')}`,
      imgURL: `${loc.protocol}//${url.replace('supportv1', 'statics')}`,
      appkey: '89025026',
      menuId: 10086,
      newMenuId: 10001,
      secret,
      iframeUrl: `${loc.protocol}//${url.replace('supportv1', 'support')}`,
      type: 'prod',
    },
  };
}

export default environment[type];
